import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CamposTorneo from './campos/CamposTorneo.js';
import MensajeError from '../UI/MensajeError.js';
import MensajeGrabando from '../UI/MensajeGrabando.js';
import usePostURL from '../../hooks/usePostURL.js';
import * as DTOs from '../DTOs/TorneoDTOs.js';
import * as Funciones from '../funciones/FuncionesTorneo.js';
import styles from './NuevoTorneo.module.css';

const NuevoTorneo = () => {
  const [torneo, setTorneo] = useState(DTOs.TorneoVacio);
  const { isGrabando, erroresPost, postData, resetErroresPost } = usePostURL();
  const navigate = useNavigate();

  console.log('NuevoTorneo', torneo);

  const onCampoChange = (campo, valor) => {
    if (erroresPost && erroresPost.length > 0) {
      resetErroresPost();
    }
    const torneoActualizado = Funciones.OnCampoTorneoChange(torneo, campo, valor);
    setTorneo(torneoActualizado);
  };

  const datosGrabados = (response) => {
    resetErroresPost();
    // response puede ser Location (string) o data (object con id)
    let idTorneo = null;

    if (typeof response === 'string') {
      // Location header: extraer último segmento de la URL
      const segments = response.split('/');
      idTorneo = segments[segments.length - 1];
    } else if (response && typeof response === 'object' && response.id) {
      // Objeto con id
      idTorneo = response.id;
    }

    if (idTorneo) {
      navigate(`/torneos/${idTorneo}`);
    } else {
      // Si no se pudo obtener el ID, navegar a la lista
      navigate('/torneos');
    }
  };

  const onAceptar = async (event) => {
    event.preventDefault();
    const error = Funciones.ValidarTorneo(torneo);
    if (error !== '') {
      alert(error);
      return;
    }

    const torneoDTO = DTOs.torneoToDTO(torneo);
    postData('/torneos', torneoDTO, datosGrabados);
  };

  const onCancelar = () => {
    navigate('/torneos');
  };

  return (
    <div className={`${styles.contenedor}`}>
      <div className={`${styles.cuadroDatos}`}>
        <div className={`${styles.tituloCuadroDatos}`}>Nuevo Torneo</div>

        <CamposTorneo torneo={torneo} editar={true} onCampoChange={onCampoChange} />

        <div className={`${styles.botonera}`}>
          <button onClick={onCancelar}>Cancelar</button>
          <button onClick={onAceptar}>Aceptar</button>
        </div>

        <MensajeError estilo={`${styles.error}`} errores={erroresPost} />
      </div>
      <MensajeGrabando estilo={`${styles.grabando}`} isGrabando={isGrabando} />
    </div>
  );
};

export default NuevoTorneo;
